import { SVGProps, Ref, forwardRef } from 'react';

export const AstrostarFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.772 2.602C9.464 3.15 8.8 3.464 8.695 3.94a1 1 0 0 0 0 .45c.106.476.769.79 2.077 1.338.548 1.308.862 1.971 1.339 2.077.148.033.301.033.45 0 .476-.106.79-.769 1.338-2.077 1.309-.548 1.971-.862 2.078-1.339a1 1 0 0 0 0-.45c-.107-.476-.77-.79-2.078-1.339-.548-1.307-.862-1.97-1.339-2.076a1 1 0 0 0-.45 0c-.476.106-.79.769-1.338 2.077"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="m7.814 7.684-.25-.599C6.754 5.142 6.35 4.17 5.663 4.17S4.57 5.142 3.76 7.085l-.25.599-.598.25c-1.944.81-2.915 1.214-2.915 1.9 0 .688.971 1.093 2.915 1.902l.599.25.25.598c.81 1.944 1.214 2.916 1.9 2.916.688 0 1.093-.972 1.903-2.916l.249-.598.598-.25c1.944-.81 2.916-1.215 2.916-1.901 0-.687-.972-1.092-2.916-1.902z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
AstrostarFilledSize16Glyph.displayName = 'AstrostarFilledSize16Glyph';
